(() => {
  if (window.bdmCardUxReady) return;
  window.bdmCardUxReady = true;

  const rootUrl = () => window.Shopify?.routes?.root || "/";
  const cartSections = ["ajax-cart", "ajax-cart-icon"];

  function setLoading(control, loading) {
    if (!control) return;
    control.classList.toggle("loading", loading);
    control.toggleAttribute("aria-busy", loading);
    const loader = control.querySelector(".ajax-loader");
    if (loader) loader.classList.toggle("hidden", !loading);
  }

  function showFormError(form, message) {
    const wrapper = form?.closest("cart-action")?.querySelector(".pr-form-error");
    const text = wrapper?.querySelector(".pr-form-error-text");
    if (!wrapper || !text) return;
    text.textContent = message;
    wrapper.hidden = !message;
  }

  function showControlError(control, message) {
    if (!control) return;
    const host =
      control.closest(".product-content, .product-form, .cart-drawer-recommendation__action") ||
      control.parentElement;
    if (!host) return;
    let region = host.querySelector(":scope > .bdm-commerce-error");
    if (!message) {
      if (region) region.remove();
      return;
    }
    if (!region) {
      region = document.createElement("p");
      region.className = "bdm-commerce-error";
      region.setAttribute("role", "alert");
      host.append(region);
    }
    region.textContent = message;
  }

  function sectionDocument(markup) {
    return new DOMParser().parseFromString(markup || "", "text/html");
  }

  function replaceCartSections(state, opener) {
    const drawer = document.querySelector("ajax-cart");
    const drawerMarkup = state.sections?.["ajax-cart"];
    const iconMarkup = state.sections?.["ajax-cart-icon"];

    const drawerWasRendered = Boolean(drawer && drawerMarkup);
    if (drawerWasRendered) {
      const updatedDrawer = sectionDocument(drawerMarkup).querySelector("#ajaxcart");
      const currentDrawer = drawer.querySelector("#ajaxcart");
      if (updatedDrawer && currentDrawer) currentDrawer.innerHTML = updatedDrawer.innerHTML;
      drawer.classList.remove("is-empty");

      if (typeof drawer.open === "function") {
        drawer.open(opener);
      } else {
        drawer.classList.add("animate", "active");
      }
    }

    if (iconMarkup) {
      const updatedCount = sectionDocument(iconMarkup).querySelector(".bigcounter");
      if (updatedCount) {
        document.querySelectorAll(".bigcounter").forEach((count) => {
          count.innerHTML = updatedCount.innerHTML;
        });
      }
    }

    const liveRegion = document.getElementById("ajaxcart-liveregiontext");
    if (liveRegion) {
      liveRegion.textContent = "Producto agregado al carrito";
      liveRegion.setAttribute("aria-hidden", "false");
    }
    return drawerWasRendered;
  }

  async function addVariant({ variantId, quantity = 1, control, form }) {
    if (!variantId || control?.hasAttribute("aria-busy")) return;

    setLoading(control, true);
    if (control) control.setAttribute("aria-disabled", "true");
    showFormError(form, "");
    showControlError(control, "");

    try {
      const response = await fetch(`${rootUrl()}cart/add.js`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Accept: "application/json",
          "X-Requested-With": "XMLHttpRequest",
        },
        body: JSON.stringify({
          items: [{ id: Number(variantId), quantity: Number(quantity) || 1 }],
          sections: cartSections,
          sections_url: window.location.pathname,
        }),
      });
      const state = await response.json();

      if (!response.ok || state.status) {
        throw new Error(
          state.description || state.message || "No se pudo agregar el producto."
        );
      }

      const modal = control?.closest("popup-view");
      if (modal) {
        if (typeof modal.hide === "function") {
          modal.hide(false);
        } else {
          modal.removeAttribute("open");
          const modalContent = modal.querySelector('[id^="QuickAddInfo-"]');
          if (modalContent) modalContent.innerHTML = "";
          modal.openedBy?.focus?.();
        }
      }

      const drawerWasRendered = replaceCartSections(state, control);
      if (typeof window.live === "function" && window.SP_OBJECT) {
        window.live(window.SP_OBJECT.ajxcartRefresh, { source: "bdm-commerce" });
      }
      if (!drawerWasRendered) {
        const cartUrl = window.routes?.cart_url || `${rootUrl()}cart`;
        window.location.assign(cartUrl);
      }
    } catch (error) {
      console.error("Unable to add product to cart:", error);
      showFormError(form, error.message);
      showControlError(control, error.message);
      const errorRegion = document.getElementById("ajaxcart-carterrors");
      if (errorRegion) errorRegion.textContent = error.message;
    } finally {
      setLoading(control, false);
      if (control && !control.disabled) control.removeAttribute("aria-disabled");
    }
  }

  function reinjectScripts(container) {
    container.querySelectorAll("script").forEach((oldScript) => {
      const script = document.createElement("script");
      Array.from(oldScript.attributes).forEach((attribute) => {
        script.setAttribute(attribute.name, attribute.value);
      });
      script.textContent = oldScript.textContent;
      oldScript.replaceWith(script);
    });
  }

  async function openProductModal(wrapper, opener) {
    const modalSelector = wrapper.getAttribute("data-modal");
    const modal = modalSelector && document.querySelector(modalSelector);
    const productUrl = opener.dataset.productUrl;
    if (!modal || !productUrl || opener.hasAttribute("aria-busy")) return;

    setLoading(opener, true);
    opener.setAttribute("aria-disabled", "true");

    try {
      const response = await fetch(productUrl, {
        headers: { "X-Requested-With": "XMLHttpRequest" },
      });
      if (!response.ok) throw new Error(`Quick add request failed (${response.status})`);

      const responseDocument = sectionDocument(await response.text());
      const productSection = responseDocument.querySelector('section[id^="MainProduct-"]');
      if (!productSection) throw new Error("Quick add product section was not found");

      productSection.querySelectorAll("product-modal, modal-dialog, pickup-availability").forEach(
        (element) => element.remove()
      );

      const sectionId = productSection.dataset.section;
      if (sectionId) {
        const replacement = `quickadd-${modal.id.replace(/[^a-zA-Z0-9_-]/g, "-")}`;
        productSection.innerHTML = productSection.innerHTML
          .split(sectionId)
          .join(replacement);
        productSection.querySelectorAll("selects-box, pr-option, product-info").forEach((element) => { element.dataset.originalSection = sectionId; });
      }

      const modalContent = modal.querySelector('[id^="QuickAddInfo-"]');
      if (!modalContent) throw new Error("Quick add modal container was not found");
      modalContent.innerHTML = productSection.innerHTML;
      reinjectScripts(modalContent);
      const variantInput = modalContent.querySelector("form [name='id']");
      if (variantInput) variantInput.disabled = false;
      const detailsLink = modal.querySelector("[data-bdm-quickview-details]");
      if (detailsLink) {
        const sourceUrl = new URL(productUrl, window.location.origin);
        const variantId = sourceUrl.searchParams.get("variant");
        if (variantId) {
          const detailsUrl = new URL(detailsLink.getAttribute("href"), window.location.origin);
          detailsUrl.searchParams.set("variant", variantId);
          detailsLink.href = detailsUrl.toString();
        }
      }

      modal.openedBy = opener;
      modal.setAttribute("open", "");
      modal.dataset.bdmFallbackOpen = "true";
      const dialog = modal.querySelector('[role="dialog"]');
      if (dialog) dialog.focus();
    } catch (error) {
      console.error("Unable to open quick add:", error);
      showControlError(
        opener,
        "No se pudieron cargar las opciones. Abrí el producto para continuar."
      );
    } finally {
      setLoading(opener, false);
      opener.removeAttribute("aria-disabled");
    }
  }

  function updateCardVariant(option) {
    const card = option.closest(".single-product-wrap");
    if (!card) return;

    option
      .closest(".option-block")
      ?.querySelectorAll(".variant-option")
      .forEach((item) => item.classList.remove("active-variant"));
    option
      .closest(".option-block")
      ?.querySelectorAll(".item-data[aria-pressed]")
      .forEach((item) => item.setAttribute("aria-pressed", "false"));
    option.closest(".variant-option")?.classList.add("active-variant");
    option.setAttribute("aria-pressed", "true");

    const variantId = option.dataset.variantId;
    const available = option.dataset.available !== "false";
    const quickAdd = card.querySelector(".bdm-card-add [data-product-url]");
    const variantLoaders = card.querySelectorAll("[data-product-url]");
    const directAdd = card.querySelector(
      "[data-cart-drawer-add], [data-bdm-direct-add], [id^='pro-add-'][data-id]"
    );
    const variantUrlValue = option.dataset.url || option.getAttribute("dataurl");
    const selectedUrl = new URL(
      variantUrlValue || quickAdd?.dataset.productUrl || window.location.href,
      window.location.origin
    );

    if (variantId) selectedUrl.searchParams.set("variant", variantId);

    card.dataset.selectedVariantId = variantId || "";
    card
      .querySelectorAll(
        ".product-image a[href], .product-content h6 a[href], .swatch-more[href], .bdm-card-view-product[href]"
      )
      .forEach((link) => {
        link.href = selectedUrl.toString();
      });

    const selectedImage = option.getAttribute("dataimg");
    const cardImage = card.querySelector(".product-image .img1 img");
    if (cardImage && selectedImage) {
      cardImage.src = selectedImage;
      cardImage.srcset = selectedImage;
    }

    const price = option.getAttribute("dataprice");
    const comparePrice = option.getAttribute("datacompare");
    const newPrice = card.querySelector(".price-box .new-price");
    const oldPrice = card.querySelector(".price-box .old-price");
    if (newPrice && price && window.Shopify?.formatMoney) {
      newPrice.textContent = Shopify.formatMoney(price, window.money_format);
    }
    if (oldPrice && window.Shopify?.formatMoney) {
      const hasComparison = Number(comparePrice) > Number(price);
      oldPrice.hidden = !hasComparison;
      oldPrice.style.display = hasComparison ? "" : "none";
      if (hasComparison) {
        oldPrice.textContent = Shopify.formatMoney(comparePrice, window.money_format);
      }
    }

    if (variantId) {
      variantLoaders.forEach((loader) => {
        const url = new URL(loader.dataset.productUrl || selectedUrl, window.location.origin);
        url.searchParams.set("variant", variantId);
        url.searchParams.set("view", "main-product");
        loader.dataset.productUrl = url.toString();
      });
    }

    if (directAdd && variantId) {
      directAdd.dataset.id = variantId;
      directAdd.disabled = !available;
    }
  }

  document.addEventListener(
    "submit",
    (event) => {
      const form = event.target.closest(
        "cart-action form, form[data-type='add-to-cart-form']"
      );
      if (!form) return;

      event.preventDefault();
      event.stopImmediatePropagation();

      const variantInput = form.querySelector("[name='id']");
      const quantityInput = form.querySelector("[name='quantity']");
      const control =
        event.submitter || form.querySelector("[type='submit'][name='add']");
      if (!variantInput || control?.disabled) return;

      addVariant({
        variantId: variantInput.value,
        quantity: quantityInput?.value || 1,
        control,
        form,
      });
    },
    true
  );

  document.addEventListener(
    "click",
    (event) => {
      const closeButton = event.target.closest(
        "popup-view [id^='stclose-'], popup-view .modal-close"
      );
      if (closeButton) {
        event.preventDefault();
        const modal = closeButton.closest("popup-view");
        if (modal && typeof modal.hide === "function") {
          modal.hide(false);
        } else {
          modal?.removeAttribute("open");
          const modalContent = modal?.querySelector('[id^="QuickAddInfo-"]');
          if (modalContent) modalContent.innerHTML = "";
        }
        return;
      }

      const option = event.target.closest(".item-data[data-variant-id]");
      if (option) {
        updateCardVariant(option);
        return;
      }

      const directAdd = event.target.closest(
        "[data-cart-drawer-add], [data-bdm-direct-add], [id^='pro-add-'].ajax-cart-btn[data-id]"
      );
      if (directAdd) {
        event.preventDefault();
        event.stopImmediatePropagation();
        if (!directAdd.disabled) {
          addVariant({
            variantId: directAdd.dataset.id,
            quantity: 1,
            control: directAdd,
          });
        }
        return;
      }

      const modalOpener = event.target.closest("qv-modal .quick-add-btn");
      if (modalOpener) {
        event.preventDefault();
        event.stopImmediatePropagation();
        openProductModal(modalOpener.closest("qv-modal"), modalOpener);
      }
    },
    true
  );
})();
